import { Injectable } from '@angular/core';

export interface TranslatableElement  {
  translations?: TranslationElement[]
 
}

export interface TranslationElement {
  locale: string,
  [prop: string]: any
}

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor() { }


  getTranslation<T extends TranslatableElement >(value: T, field: keyof T, locale: string): string {
    
    let text: any;

    if (locale !== "en" && value?.translations) {
      text = (value.translations.find(t => t.locale === locale) as any)?.[field]
    }

    if (!text) {
      text = value[field]
    }
   

    return String(text)

  }

}
